import { useCallback, useState } from 'react'

export default function useCoda(arrayIniziale = []) {
  const [elementi, setElementi] = useState(arrayIniziale)

  const aggiungiInCoda = useCallback((nuovoElemento, sostituisciUltimoElemento = false) => {
    setElementi(elementi => {
      if (!sostituisciUltimoElemento) return [...elementi, nuovoElemento]
      const elementiSenzaUltimo = elementi.slice(0, elementi.length - 1)
      return [...elementiSenzaUltimo, nuovoElemento]
    })
  }, [])

  const eliminaDallaCoda = useCallback(elementoDaEliminare => {
    setElementi(elementi => {
      const indiceElementoDaEliminare = elementi.findIndex(el => el === elementoDaEliminare)
      return [
        ...elementi.slice(0, indiceElementoDaEliminare),
        ...elementi.slice(indiceElementoDaEliminare + 1, elementi.length)
      ]
    })
  }, [])

  const isCodaVuota = useCallback(() => {
    return elementi.length === 0
  }, [elementi.length])

  const getLunghezzaCoda = useCallback(() => {
    return elementi.length
  }, [elementi.length])

  const getCopiaCoda = useCallback(() => {
    return [...elementi]
  }, [elementi])

  return {
    primoElementoInCoda: elementi[0],
    ultimoElementoInCoda: elementi[elementi.length - 1],
    aggiungiInCoda,
    eliminaDallaCoda,
    isCodaVuota,
    getLunghezzaCoda,
    getCopiaCoda
  }
}